export const broadcasts = {
  state: {
    broadcasts: [],
    selectedBroadcast: null,
    broadcastReceivers: null,
  },
  getters: {
    'broadcasts/query': state => query => {
      const fallback = []
      if (!state.broadcasts || !state.broadcasts.length) return fallback
      const result = state.broadcasts.filter(
        broadcast =>
          broadcast.name.toLowerCase().includes(query.toLowerCase())
      )
      return result && result.length ? result.reverse() : fallback
    }
  },
  mutations: {
    'broadcasts/add': function(state, data) {
      state.broadcasts.splice(0, 0, data)
    },
    'broadcasts/set': function(state, data) {
      state.broadcasts = data
    },
    'broadcasts/select': function(state, data) {
      state.selectedBroadcast = data
    },
    'broadcasts/select/recievers': function(state, data) {
      state.broadcastReceivers = data
    }
  },
  actions: {
    'broadcasts/get': async function({ commit, dispatch, getters }, payload) {
      try {
        const botId = getters['bot/id']
        if(!botId)
          return false
        dispatch('setLoader', true)
        const { data } = await this._vm.$http_chat({
          method: 'get',
          url: '/broadcasts',
          params: { 'filter[bot]': botId }
        })
        dispatch('setLoader', false)
        const { broadcasts } = data.data
        commit('broadcasts/set', broadcasts)
        return broadcasts
      } catch (err) {
        dispatch('setLoader', false)
        commit('broadcasts/set', [])
        throw new Error(err)
      }
    },
    'broadcasts/get/current': async function(
      { commit, dispatch, state },
      payload
    ) {
      try {
        dispatch('setLoader', true)
        const { data } = await this._vm.$http_chat.get(`/broadcasts/${payload}`)
        dispatch('setLoader', false)
        const result = data.data
        commit('broadcasts/select', result)
        return result
      } catch (err) {
        dispatch('setLoader', false)
        commit('broadcasts/select', null)
        throw new Error(err)
      }
    },
    'broadcasts/get/current/receivers': async function(
      { commit, dispatch, state },
      payload
    ) {
      try {
        dispatch('setLoader', true)
        const { data } = await this._vm.$http_chat.get(`/broadcasts/${payload}/receivers`)
        dispatch('setLoader', false)
        const result = data.data
        commit('broadcasts/select/recievers', result)
        return result
      } catch (err) {
        dispatch('setLoader', false)
        commit('broadcasts/select/recievers', null)
        throw new Error(err)
      }
    },
    'broadcasts/add': async function({ commit, dispatch }, payload) {
      try {
        const { data } = await this._vm.$http_chat.post('/broadcasts', payload)
        dispatch('broadcasts/get')
        return data
      } catch (err) {
        throw new Error(err)
      }
    },
    'broadcasts/update': async function({ commit, dispatch }, payload) {
      try {
        const { data } = await this._vm.$http_chat.put(`/broadcasts/${payload.id}`, {
          name: payload.name
        })
        dispatch('broadcasts/get')
        return data
      } catch (err) {
        throw new Error(err)
      }
    },
    'broadcasts/delete': async function({}, id) {
      try {
        await this._vm.$http_chat.delete(`/broadcasts/${id}`)
        return true
      } catch (err) {
        throw new Error(err)
        return false
      }
    },
    'broadcasts/publish': async function({ dispatch, state }) {
      try {
        dispatch('setLoader', true)
        await this._vm.$http_chat.post(`/broadcasts/${state.selectedBroadcast.id}/publish`)
        dispatch('setLoader', false)
        return true
      } catch (err) {
        dispatch('setLoader', false)
        if (err.response.status === 400)
        dispatch('setErrorMessage', 'You must train your broadcast first')
        throw new Error(err)
        return false
      }
    },
    'broadcasts/delete/single': async function({ dispatch }, id) {
      try {
        await this._vm.$http_chat.delete(`/broadcasts/${id}`)
        dispatch('broadcasts/get')
        return true
      } catch (err) {
        throw new Error(err)
        return false
      }
    },
    'broadcasts/sync/single': async function({ dispatch }, id) {
      try {
        await this._vm.$http_chat.post(`/broadcasts/${id}/sync`)
        dispatch('broadcasts/get')
        return true
      } catch (err) {
        throw new Error(err)
        return false
      }
    },
    'broadcasts/delete/multiple': async function({ dispatch }, payload) {
      try {
        dispatch('setLoader', true)
        let i
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch('broadcasts/delete', payload[i].id)
          } catch (err) {
            dispatch('setLoader', false)
            throw new Error(err)
            return false
          }
          if (index === payload.length - 1) return dispatch('broadcasts/get')
        }
      } catch (err) {
        throw new Error(err)
      }
    },
    'broadcasts/set': function({ commit }, data) {
      commit('broadcasts/set', result)
      return result
    },
    'broadcasts/select': function({ commit }, data) {
      commit('broadcasts/select', data)
    }
  }
}
